import styled from 'styled-components'

// Wrapper
// ============================================================
export const PaginationStyle = styled.div`
  /* Parent
  ------------------------------- */
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;

  /* Childrens
  ------------------------------- */
  .paginations {
    display: flex;
    align-items: center;
    gap: 2px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .pagination {
    border: 0;
    width: 28px;
    height: 28px;
    min-width: 28px;
    max-height: 28px;
    min-height: 0;
    flex: 0 0 28px;
    display: flex;
    border-radius: 8px;
    font-size: 13px;
    line-height: 1;
    font-weight: 500;
    color: #1f2937;

    .link {
      display: flex;
      color: #1f2937;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      margin-bottom: 0;
      border-radius: 8px;

      .icon {
        height: 14px;
        width: auto;

        .image {
          vertical-align: top;
          width: auto;
          height: 100%;
        }
      }
    }

    &:first-child,
    &:last-child {
      display: none;
    }

    &.nav {
      width: 28px;
      height: 28px;
      min-width: 28px;
      max-height: 28px;
      flex-basis: 28px;
    }

    &.active {
      background-color: #eef1ff;

      .link {
        color: #4b4acb;
      }

      &:hover {
        background-color: #eef1ff;

        .link {
          color: #4b4acb;
        }
      }
    }

    &.disabled {
      opacity: 0.4;
      pointer-events: none;

      &:hover {
        background-color: transparent;
      }
    }

    &:hover {
      background-color: #f1f2f8;

      .link {
        color: #1f2937;
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1024.98px) {
    .pagination {
      width: 26px;
      height: 26px;
      min-width: 26px;
      max-height: 26px;
      flex-basis: 26px;
      font-size: 12px;

      &.nav {
        width: 26px;
        height: 26px;
        min-width: 26px;
        max-height: 26px;
        flex-basis: 26px;
      }
    }
  }
`
